export const PAGE_NAME = 'hybridPDP';
export const SIZE_GUIDE_LOCATION = `${PAGE_NAME}:sizeguide`;

export const HYBRID_PDP_VERSION = {
  LEGACY: '1.0',
  V2: '2.0',
};

export const EVENTS = {
  PAGE_VIEW: 'hybrid_pdp_loads',
  MORE_DETAILS_CLICK: 'pdp_more_details_click',
  IMAGE_SCROLL: 'pdp_image_scroll',
  GALLERY_CLICK: 'pdp_image_click',
  WIDGET_LISTING_UPDATE: 'hybrid_pdp_load_more',
  WIDGET_CLICK: 'hybrid_pdp_widget_click',
  WIDGET_VIEW_ALL_CLICK: 'hybrid_pdp_widget_view_all_click',
  CAROUSEL_VIEWED: 'hybrid_pdp_smart_carousel_viewed',
  CAROUSEL_OPENED: 'hybrid_pdp_smart_carousel_opened',
  CAROUSEL_CLOSED: 'hybrid_pdp_smart_carousel_closed',
  SHARE_CLICK: 'share_btn_click',
  CAROUSEL_PRODUCT_VIEWED: 'hybrid_pdp_smart_carousel_product_viewed',
  PDP_OPENED_FROM_CAROUSEL: 'hybrid_pdp_pdp_opened_from_carousel',
};

export const VARIANT_IDENTIFER = {
  HP: 'VariantA',
  HC: 'VariantB',
  V2: 'VariantC',
};
